import type { CommercialCycle, GenerateDraftRun } from "@/lib/api";

// ─── Query Keys ──────────────────────────────────────────────────────────────
export const CYCLE_QUERY_KEYS = {
  list: ["commercial-cycles"] as const,
  generateDraftRuns: ["generate-draft-runs"] as const,
  generateDraftRun: (runId: number) => ["generate-draft-run", runId] as const,
  generateDraftRunProgress: (runId: number) =>
    ["generate-draft-run-progress", runId] as const,
  generateDraftRunsByPair: (sourceYear: string, targetYear: string) =>
    ["generate-draft-runs", sourceYear, targetYear] as const,
  rolloverSchedules: ["rollover-schedules"] as const,
} as const;

// ─── Status badge mapping ────────────────────────────────────────────────────
export const STATUS_BADGE: Record<
  CommercialCycle["status"],
  { label: string; variant: "secondary" | "success" | "outline" }
> = {
  Draft: { label: "Rascunho", variant: "secondary" },
  Published: { label: "Publicado", variant: "secondary" },
  Open: { label: "Aberto", variant: "success" },
  Closing: { label: "Em fechamento", variant: "outline" },
  Closed: { label: "Fechado", variant: "outline" },
};

/** Status de uma linha de execução/agendamento de tombamento (GenerateDraftRun). */
export const RUN_STATUS_BADGE: Record<
  GenerateDraftRun["status"],
  { label: string; variant: "secondary" | "success" | "destructive" | "outline" }
> = {
  Scheduled: { label: "Agendado", variant: "outline" },
  Running: { label: "Em execução", variant: "secondary" },
  Triggered: { label: "Disparado", variant: "secondary" },
  Completed: { label: "Concluído", variant: "success" },
  Failed: { label: "Falhou", variant: "destructive" },
  Cancelled: { label: "Cancelado", variant: "outline" },
};

// ─── Formatação de data ──────────────────────────────────────────────────────
export const formatDateValue = (value?: string | null): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

/** Formata data+hora (ex.: campos de run/agendamento) convertendo de UTC para o fuso local. */
export const formatDateTimeValue = (value?: string | null): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
